export function getStatusBadgeMod(status) {
    if (['winning', 'paid', 'to_be_paid', 'win'].includes(status)) return 'sc__status-badge--won';
    if (status === 'winning_cashback')                       return 'sc__status-badge--cashout';
    if (status === 'losing')                                 return 'sc__status-badge--lost';
    return ''; // open, in_progress, live)
}
 